import api from "./api";

export default {
  mixins: [ api ],
  methods: {
    // Получение списка объектов
    async getLocations(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);

      if (data.town > 0 ) {
        params.set("town", this.filters.town);
      }

      if (data.customer_id > 0) {
        params.set("customer_id", data.customer_id);
      }

      return await this.get(`locations?${params.toString()}${sorting}`);
    },
    // Получение объекта по id
    async getLocationById(id) {
      return await this.get(`locations/id/${id}`);
    },
    // Создание объекта
    async postLocation(data) {
      return await this.post('locations', data);
    },
    // Изменение объекта
    async putLocation(data) {
      return await this.put(`locations/id/${data.id}`, data);
    },
    // Удаление объекта
    async deleteLocation(data) {
      return await this.delete(`locations/id/${data.id}`, null);
    },
    // Получение объектов по запросу
    async getLocationsSearch(data) {
      let params = this.makeSearchParams(data);

      if (data.payment_type_int > -1) {
        params.set("payment_type_int", data.payment_type_int);
      }

      return await this.get(`locations/search?${params.toString()}`);
    },
    // Получение объектов с фильтрацией по дате
    async getLocationsSearchByDate(data) {
      let params = this.makeSearchParams(data);

      if (data.start_date != null) {
        params.set("start_date", data.start_date);
      }

      if (data.end_date != null) {
        params.set("end_date", data.end_date);
      }

      if (data.payment_type_int > -1) {
        params.set("payment_type_int", data.payment_type_int);
      }

      return await this.get(`locations/period?${params.toString()}`);
    },

    // Получение работы объекта по id
    async getLocationWorkById(id) {
      return await this.get(`locations/works/id/${id}`);
    },
    // Создание работы объекта
    async postLocationWorks(data) {
      return await this.post(`location_works/location_id/${data.id}`, data);
    },
    // Получение работы объекта в заявке
    async getTaskLocationWorksByTaskId(id) {
      return await this.get(`location_works/location_id/${id}`);
    },

    // Получение контактов объекта
    async getLocationContactsById(id) {
      return await this.get(`location_contacts/location_id/${id}`);
    },
    // Создание контактов объекта
    async postLocationContacts(data, id) {
      return await this.post(`location_contacts/location_id/${id}`, data);
    },

    // Получение расходов объекта по id
    async getLocationCostsById(id) {
      return await this.get(`location_costs/id/${id}`);
    },
    // Создание расходов объекта
    async postLocationCosts(data, id) {
      return await this.post(`location_costs/${id}`, data);
    },
    // Получение суммы расходов объекта по id
    async getLocationCostSumById(id, date) {
      return await this.get(`location_costs/id/${id}/summary?date=${date}`);
    },

    // Получение группы медиа объекта
    async getLocationMedia(locationId) {
      return await this.get(`locations/${locationId}/passports`);
    },
    // Создание группы медиа объекта
    async postLocationMedia(data) {
      return await this.post(`locations/${data.location_id}/passports`, data);
    },
    // Изменение группы медиа объекта
    async putLocationMedia(data) {
      return await this.put(`locations/${data.location_id}/passports/${data.id}`, data);
    },
    // Удаление группы медиа объекта
    async deleteLocationMedia(data) {
      return await this.delete(`locations/${data.location_id}/passports/${data.id}`, null);
    },

    // Получение списка файлов медиа объекта
    async getLocationMediaFiles(data) {
      return await this.get(`locations/${data.location_id}/passports/${data.id}/files`);
    },
    // Создание файлов медиа объекта
    async postLocationMediaFiles(locationId, passportId, data) {
      return await this.post(`locations/${locationId}/passports/${passportId}/files`, data);
    },
    // Загрузка файлов медиа объекта
    async getLocationMediaFileDownload(locationId, passportId, fileId) {
      return await this.getFile(`locations/${locationId}/passports/${passportId}/files/${fileId}/download`);
    },
    // Удаление файлов медиа объекта
    async deleteLocationMediaFiles(locationId, passportId, fileId) {
      return await this.delete(`locations/${locationId}/passports/${passportId}/files/${fileId}`, null);
    },

    // Получение списка файлов объекта
    async getLocationFilesByLocationId(id) {
      return await this.get(`location_files/location_id/${id}`);
    },
    // Загрузка файла объекта
    async getLocationFile(id) {
      return await this.getFile(`location_files/id/${id}`);
    },
    // Отправка файла объекта
    async postLocationFile(locationId, data) {
      return await this.post(`location_files/${locationId}`, data);
    },
    // Удаление файла объекта
    async deleteLocationFile(data) {
      return await this.delete(`location_files/${data.id}`, null)
    },

    // Получение объектов заказчика
    async getLocationsByCustomerId(id) {
      return await this.get(`locations?customer_id/${id}`);
    },
  }
}



// WEBPACK FOOTER //
// ./src/network/locations.js